import {
  Box,
  Button,
  ButtonGroup,
  Popover,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverFooter,
  PopoverHeader,
  PopoverTrigger,
  Text,
} from '@chakra-ui/react'
import type { Dispatch, SetStateAction } from 'react'

import { FONT_SIZES } from '@/constants/constants'

export default function CourseFollowPopover({
  followButton,
  FollowTopicBody,
  popoverIsOpen,
  setPopoverIsOpen,
  courseName,
  onSubmit,
}: {
  followButton: React.ReactElement
  FollowTopicBody: React.FC
  popoverIsOpen: boolean
  setPopoverIsOpen: Dispatch<SetStateAction<boolean>>
  courseName: string | null
  onSubmit: () => void
}): JSX.Element | null {
  return (
    <Popover placement="bottom-start" isOpen={popoverIsOpen} closeOnBlur>
      <PopoverTrigger>
        <Box role="button">{followButton}</Box>
      </PopoverTrigger>
      <PopoverContent
        w="600px"
        maxW="calc(100vw - 48px)"
        p="16px"
        boxShadow="0px 4px 9px rgba(0, 0, 0, 0.16)"
        bgColor="bg"
        zIndex="10 !important"
      >
        <PopoverCloseButton onClick={() => setPopoverIsOpen(false)} border="none" bgColor="bg" />
        <PopoverHeader>
          <Text fontWeight="bold" m={0} fontSize={FONT_SIZES.display3}>
            Follow {courseName} Topics
          </Text>
        </PopoverHeader>
        <PopoverBody>
          <FollowTopicBody />
        </PopoverBody>
        <PopoverFooter display="flex" justifyContent="flex-end">
          <ButtonGroup>
            <Button variant="outline" onClick={() => setPopoverIsOpen(false)}>
              Cancel
            </Button>
            <Button border="none" onClick={onSubmit}>
              Apply
            </Button>
          </ButtonGroup>
        </PopoverFooter>
      </PopoverContent>
    </Popover>
  )
}
